import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { serverApi } from '../../../api'
import { SocketContext } from '../../../context/SocketContext'
import { useHideMenu } from '../../../hooks/useHideMenu'

import { getUsuarioStorage } from '../../../helpers/getUsuarioStorage'
import { CrearRolModal } from './CrearRolModal'

const pasarMayusculas = (ev) => {
    ev.preventDefault();
    ev.target.defaultValue = ev.target.defaultValue.toUpperCase();
    ev.target.value = ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

export const Roles = () => {

    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);
    useHideMenu(false);

    // const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'rol',
        sortDir: 'asc',
        ubicacion: '',
        codigoUbicacion: ''
    });


    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.ceil(total / query.limit);

    const [searchInput, setSearchInput] = useState('');



    const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000 }) }
    const sweetConfirm = (title, html, icon) => {
        return MySwal.fire({
            title,
            html,
            icon,
            confirmButtonText: 'Ok',
            confirmButtonColor: 'LightSeaGreen',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar'
        })
    }

    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])


    useEffect(() => {

        const codigoEntidad = usuario.codigoEntidad
        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);
                // const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
                console.log(query);
                const resp = await serverApi.post(
                    `/usuarios/lista-roles`,
                    {
                        ...query,
                        codigoEntidad,
                    }
                );

                setData(resp.data.lista || []);
                setTotal(resp.data.total || 0);

            } catch (error) {
                console.error("Error al obtener tipos de atención", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();

    }, [query, usuario.codigoEntidad])


    useEffect(() => {
        if (!socket) return;

        const handler = (lista) => {
            console.log(lista);
            setData(lista.lista);
        };

        socket.on('lista-roles', handler);
        return () => {
            socket.off('lista-roles')
        }

    }, [socket])

    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 800);

        return () => clearTimeout(timeout);

    }, [searchInput]);


    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };

    const inactivaRol = async (uidRol, accion) => {

        console.log(isLoading);
        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');


        const act = accion === 1 ? "Activar" : "Inactivar";
        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })
        if (!confirmacion.value) return false;

        try {
            setIsLoading(true);

            await serverApi.post(
                `/usuarios/inactiva-rol`,
                {
                    ...query,
                    uidRol,
                    accion,
                    codigoEntidad,
                    codigoUbicacion
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const registraRol = async (info) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/usuarios/registra-rol`,
                {
                    ...info,
                    codigoEntidad,
                    codigoUbicacion
                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
            }

        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }


    }

    const editaRol = async (ev, uidRol) => {

        const campo = ev.target.id.split("_")[0];
        const valor = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.value;
        const valorAnterior = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.defaultValue;


        if (valor === valorAnterior) return;

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {
            setIsLoading(true);

            await serverApi.post(
                `/usuarios/edita-rol`,
                {
                    ...query,
                    campo,
                    valor,
                    uidRol,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);

        }

    }


    return (
        <div>

            <div className='row'>
                <div className='col-lg-2 col-12 '>
                    <button
                        className='btn btn-success m-3'
                        onClick={() => setShowModal(true)}
                    >
                        Agregar Rol
                    </button>

                    <CrearRolModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        onSave={(datos) => registraRol(datos)}
                    />

                </div>
            </div>

            <div id='divAgregaRol' className='row border border-info rounded shadow p-3 collapse hide'>
                <table className='table table-responsive table-striped ' width={'100%'} >
                    <thead>
                        <tr>
                            <th width={'5%'}></th>
                            <th width={'95%'}>Rol</th>

                        </tr>
                    </thead>
                    <tbody   >

                        <tr>

                            <td width={'5%'}>
                                <button
                                    className='btn btn-sm btn-primary me-1'
                                    onClick={() => registraRol('')}
                                >
                                    <i className='fas fa-save'></i>
                                </button>

                            </td>

                            <td width={'95%'}>
                                <input
                                    type='text'
                                    className='form-control registroRol'
                                    id='rol_'
                                />
                            </td>

                        </tr>

                    </tbody>
                </table>

            </div>

            <hr />

            <div className='row rounded shadow p-3'>

                <div className='col-12'>
                    <div className='float-start col-lg-4 col-12 pagination'>
                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(query.page - 1)}
                            disabled={query.page === 1}
                        >
                            {'<'}
                        </button>

                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(query.page + 1)}
                            disabled={data.length <= query.limit}

                        >
                            {'>'}
                        </button>
                    </div>

                    <div className=' float-end col-lg-4 col-12'>

                        <input
                            type='text'
                            placeholder='Buscar...'
                            className='form-control'
                            maxLength={20}
                            value={searchInput}
                            onChange={(ev) => setSearchInput(ev.target.value)}
                        />

                    </div>

                </div>

                <div className='col-12'>
                    <table className='table table-responsive table-striped max600' width={'100%'} >
                        <thead>
                            <tr>
                                <th width={'5%'}></th>
                                <th width={'95%'} onClick={() => handleSort('rol')} >
                                    Rol
                                    {query.sortBy === 'rol' && query.sortDir === 'asc' && '▲'}
                                    {query.sortBy === 'rol' && query.sortDir === 'desc' && '▼'}
                                </th>
                            </tr>
                        </thead>

                        <tbody width={'100%'}  >

                            {

                                data.length === 0
                                    ? (<tr>
                                        <td width={'100%'} style={{ textAlign: 'center' }}> No Hay Registros </td>
                                    </tr>
                                    )
                                    :
                                    data.map((item) => (

                                        <tr key={item.uidRol}>
                                            <td width={'5%'}>

                                                {(item.indActivo === 1)
                                                    ? (
                                                        <>
                                                            <button
                                                                className='btn btn-sm btn-danger'
                                                                onClick={() => inactivaRol(item.uidRol, 0)}
                                                            >
                                                                <i className='fa-solid fa-minus'></i>
                                                            </button>

                                                        </>
                                                    )
                                                    : (
                                                        <button
                                                            className='btn btn-sm btn-success'
                                                            onClick={() => inactivaRol(item.uidRol, 1)}
                                                        >
                                                            <i className='fa-solid fa-plus'></i>
                                                        </button>
                                                    )

                                                }



                                            </td>
                                            <td width={'95%'}>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id={`rol_${item.uidUrol}`}
                                                    defaultValue={item.rol.toUpperCase()}
                                                    maxLength={200}
                                                    onBlur={(ev) => editaRol(ev, item.uidRol)}
                                                    onChange={(ev) => pasarMayusculas(ev)}
                                                />
                                            </td>

                                        </tr>
                                    ))
                            }
                        </tbody>
                    </table>

                    <div className='pagination'>
                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(query.page - 1)}
                            disabled={query.page === 1}
                        >
                            {'<'}
                        </button>

                        <button
                            className='btn btn-sm btn-secondary m-1'
                            onClick={() => paginate(query.page + 1)}
                            disabled={data.length <= query.limit}

                        >
                            {'>'}
                        </button>
                    </div>
                </div>


            </div>


        </div>
    )

}
